"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var styled_components_1 = __importDefault(require("styled-components")); // TODO - move to utils


var getSpace = function getSpace(x) {
  return x * 4;
}; // TODO - move to utils


exports.sizes = {
  desktop: 992,
  phone: 576,
  tablet: 768
};
exports.Main = styled_components_1.default.main(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    max-width: 100%;\n    max-width: 960px;\n    position: relative;\n    margin: 0 auto;\n    padding: ", "px 0;\n    @media screen and (max-width: ", "px) {\n        padding: ", "px 0;\n    }\n"], ["\n    max-width: 100%;\n    max-width: 960px;\n    position: relative;\n    margin: 0 auto;\n    padding: ", "px 0;\n    @media screen and (max-width: ", "px) {\n        padding: ", "px 0;\n    }\n"])), function (_a) {
  var theme = _a.theme;
  return getSpace(theme.x);
}, exports.sizes.phone, function (_a) {
  var theme = _a.theme;
  return theme.x * 2;
});
exports.Header = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n    height: 40px;\n    width: 100%;\n    margin-bottom: ", "px;\n\n    .logo {\n        height: 40px;\n    }\n\n    @media screen and (max-width: ", "px) {\n        margin-bottom: ", "px;\n\n        .logo {\n            position: absolute;\n            clip: rect(0px, 48px, 48px, 0px);\n        }\n    }\n"], ["\n    position: relative;\n    height: 40px;\n    width: 100%;\n    margin-bottom: ", "px;\n\n    .logo {\n        height: 40px;\n    }\n\n    @media screen and (max-width: ", "px) {\n        margin-bottom: ", "px;\n\n        .logo {\n            position: absolute;\n            clip: rect(0px, 48px, 48px, 0px);\n        }\n    }\n"])), function (_a) {
  var theme = _a.theme;
  return getSpace(theme.x);
}, exports.sizes.phone, function (_a) {
  var theme = _a.theme;
  return theme.x * 2;
});
exports.Section = styled_components_1.default.section(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    /* margin: 6.75% 0; */\n"], ["\n    /* margin: 6.75% 0; */\n"])));
exports.Body = styled_components_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    padding: 6.75%;\n\n    :first-child {\n        margin: 0 0 16px;\n    }\n\n    @media screen and (max-width: 768px) {\n        grid-template-columns: 1fr;\n    }\n"], ["\n    padding: 6.75%;\n\n    :first-child {\n        margin: 0 0 16px;\n    }\n\n    @media screen and (max-width: 768px) {\n        grid-template-columns: 1fr;\n    }\n"])));
exports.Aside = styled_components_1.default.aside(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    background-color: #e8e9ea;\n    border-radius: 0 8px 8px 0;\n\n    @media screen and (max-width: 768px) {\n        grid-template-columns: 1fr;\n        border-radius: 0 0 8px 8px;\n    }\n"], ["\n    background-color: #e8e9ea;\n    border-radius: 0 8px 8px 0;\n\n    @media screen and (max-width: 768px) {\n        grid-template-columns: 1fr;\n        border-radius: 0 0 8px 8px;\n    }\n"])));
/**
 * @component  Styled Application Container
 */

exports.AppContainer = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    /* display: flex;\n  height: 100vh;\n  flex-direction: column; */\n"], ["\n    /* display: flex;\n  height: 100vh;\n  flex-direction: column; */\n"])));
/**
 * @component Styled top application bar
 */

exports.TopBar = styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    border-bottom: 1px solid ", ";\n    display: flex;\n    padding: ", ";\n    margin-bottom: ", ";\n"], ["\n    border-bottom: 1px solid ", ";\n    display: flex;\n    padding: ", ";\n    margin-bottom: ", ";\n"])), function (_a) {
  var theme = _a.theme;
  return theme.border.default;
}, function (props) {
  return props.theme.space.small;
}, function (props) {
  return props.theme.space.small;
});
/**
 * @component Styled content application
 * @description The content area should take the remaining area
 */

exports.Content = styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    flex: 1;\n    padding: ", ";\n"], ["\n    flex: 1;\n    padding: ", ";\n"])), function (_a) {
  var theme = _a.theme,
      noSpace = _a.noSpace;
  return noSpace ? 0 : theme.space.medium;
});
/**
 * @component Styled bottom application bar
 */

exports.BottomBar = styled_components_1.default.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    border-top: 1px solid ", ";\n    bottom: 0;\n    display: flex;\n\n    padding: ", ";\n    position: fixed;\n    width: 100%;\n"], ["\n    border-top: 1px solid ", ";\n    bottom: 0;\n    display: flex;\n\n    padding: ", ";\n    position: fixed;\n    width: 100%;\n"])), function (_a) {
  var theme = _a.theme;
  return theme.border.default;
}, function (props) {
  return props.theme.space.small;
});
exports.default = {
  Header: exports.Header,
  Main: exports.Main,
  Section: exports.Section
};
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;